import { render, staticRenderFns } from "./HumanMachineCollaborationSection.vue?vue&type=template&id=3c954998&scoped=true"
import script from "./HumanMachineCollaborationSection.vue?vue&type=script&lang=js"
export * from "./HumanMachineCollaborationSection.vue?vue&type=script&lang=js"
import style0 from "./HumanMachineCollaborationSection.vue?vue&type=style&index=0&id=3c954998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c954998",
  null
  
)

export default component.exports